// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import {
  addCustomerReviewApi,
  deleteCustomerReviewApi,
  getCustomerReviewApi
} from "../../../../services/Web/customerReview.service"
import { toastError, toastSuccess } from "../../../../utility/toastutill"

// ** Get All CustomerReview Data
export const getAllCustomerReviewData = createAsyncThunk(
  "customerReview/getAllCustomerReviewData",
  async () => {
    try {
      const response = await getCustomerReviewApi()
      if (response.data.success) {
        toastSuccess(response.data.message)
      }
      return response.data.data
    } catch (error) {
      toastError(error)
      return error
    }
  }
)

// ** Add New CustomerReview
export const addCustomerReview = createAsyncThunk(
  "customerReview/addCustomerReview",
  async (formData, { dispatch, getState }) => {
    try {
      const res = await addCustomerReviewApi(formData)
      if (res.data) {
        toastSuccess(res.data.message)
        await dispatch(getAllCustomerReviewData(getState().customerReview.params))
        await dispatch(getAllCustomerReviewData())
      }
      return res.data.success ? res.data.success : false
    } catch (error) {
      toastError(error)
      return error
    }
  }
)

// ** Delete CustomerReview
export const deleteCustomerReview = createAsyncThunk(
  "customerReview/deleteCustomerReview",
  async (id, { dispatch, getState }) => {
    try {
      const res = await deleteCustomerReviewApi(id)
      if (res.data.success) {
        toastSuccess(res.data.message)
        await dispatch(getAllCustomerReviewData(getState().customerReview.params))
        await dispatch(getAllCustomerReviewData())
      }
      return id
    } catch (error) {
      toastError(error)
      return error
    }
  }
)

export const customerReviewSlice = createSlice({
  name: "customerReview",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedContactUs: null,
    success: false,
    loading: false,
    error: null
  },
  reducers: {
    clearSelectedContactUs: (state) => {
      state.selectedContactUs = null
    },
    clearError: (state) => {
      state.error = null
    },
    clearSuccess: (state) => {
      state.success = false
    }
  },
  extraReducers: (builder) => {
    builder
      // Get All CustomerReview Data
      .addCase(getAllCustomerReviewData.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllCustomerReviewData.fulfilled, (state, action) => {
        state.loading = false
        state.allData = action.payload
        state.data = action.payload
      })
      .addCase(getAllCustomerReviewData.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Add CustomerReview
      .addCase(addCustomerReview.pending, (state) => {
        state.loading = true
        state.success = false
      })
      .addCase(addCustomerReview.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(addCustomerReview.rejected, (state, action) => {
        state.loading = false
        state.success = false
        state.error = action.payload
      })

      // Delete CustomerReview
      .addCase(deleteCustomerReview.pending, (state) => {
        state.loading = true
      })
      .addCase(deleteCustomerReview.fulfilled, (state, action) => {
        state.loading = false
        // Remove deleted item from state
        state.allData = state.allData.filter(item => item.id !== action.payload)
        state.data = state.data.filter(item => item.id !== action.payload)
      })
      .addCase(deleteCustomerReview.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearSelectedCustomerReview, clearError, clearSuccess } = customerReviewSlice.actions

export default customerReviewSlice.reducer